import React, { ReactElement, useState } from "react";
import { FiCopy } from "react-icons/fi";
import TimedMessage from "../timed-message/TimedMessage";
import Styles from "./CodeBlock.module.scss";

interface Props {
    code: string | undefined;
    shouldWrap?: boolean;
    isCopyable?: boolean;
    className?: string;
    codeClassName?: string;
    size?: "sm" | "lg"
    alert?: "info" | "danger" | "primary" | "secondary" | "none" | "light" | "gray-100" | "gray-200" | "gray-300" | "gray-400"
}

export default function CodeBlock({
    code, shouldWrap, isCopyable, className, size, alert, codeClassName,
}: Props): ReactElement {
    const [isCopied, setIsCopied] = useState(false);
    const blockRef = React.createRef<HTMLElement>();

    const doCopy = !isCopyable ? undefined : () => {
        if (code) {
            navigator.clipboard.writeText(code);
            setIsCopied(true);
        }

        if (blockRef.current) {
            const range = document.createRange();
            range.selectNodeContents(blockRef.current);
            const selection = window.getSelection();
            if (selection) {
                selection.removeAllRanges();
                selection.addRange(range);
            }
        }
    };
    return (
        <div className={`alert alert-${alert} p-0 m-0 ${className} ${
            size === "sm" ? "d-flex align-items-start justify-content-between" : ""
        }`}
        >
            {isCopyable && (
                <TimedMessage shouldShow={isCopied} seconds={3} onClose={() => setIsCopied(false)}>
                    Copied to clipboard
                </TimedMessage>
            )}
            <pre
                className={`m-0 p-3 ${
                    shouldWrap ? "pre-no-overflow" : ""} ${
                    isCopyable ? Styles.clickable : ""} ${codeClassName}`}
                onDoubleClick={doCopy}
            >
                <code ref={blockRef}>
                    {code}
                </code>

                {isCopyable && (
                    size === "lg" && (
                        <div className="d-flex justify-content-end m-0 mb-n3">
                            <small className="border">
                                Double click to copy
                            </small>
                        </div>
                    )
                )}
            </pre>

            {isCopyable && size === "sm" && (
                <button type="button" onClick={doCopy} className="btn btn-none p-0 m-0 m-2 pt-1">
                    <small>
                        <FiCopy />
                    </small>
                </button>
            )}
        </div>
    );
}

CodeBlock.defaultProps = {
    shouldWrap: false,
    isCopyable: true,
    className: undefined,
    codeClassName: undefined,
    size: "lg",
    alert: "info",
};
